import React from 'react';
import { Box, Typography, Stack } from "@mui/material";
import { useLocation } from "react-router-dom";
import MenuBar from "./MenuBar";
import Footer from "./Footer";

export function SuccessInvoicePage() {
  const location = useLocation();
  const invoiceNumber = location.state?.invoiceNumber || "your invoice";

  return (
    <div>
      <MenuBar />
      <Stack spacing={2} sx={{ 
        py: 8, 
        pb: 20, 
        maxWidth: { xs: '100%', md: '100%', lg: '100%' },
        mx: 'auto',
        px: { xs: 2, sm: 3 },
        textAlign: 'center'
      }}>
        <Box sx={{ mt: 16, mb: 4 }}>
          <Typography variant="h4">
            Thank you for your payment!
          </Typography>
          
          <Typography variant="body1" color="text.secondary">
            Invoice {invoiceNumber} is now paid in full.
          </Typography>
        </Box>
      </Stack>
      <Footer />
    </div>
  );
}